export const UTM_SOURCE = "utm_source";
export const UTM_MEDIUM = "utm_medium";
export const UTM_CAMPAIGN = "utm_campaign";
export const BTN_SOURCE = "btn_source";
export const APP_SOURCE = "app_source";
export const LANDING_PAGE = "landingPage";

export const VM_LEAD_CONTENT_KEYS_FOR_WHATSAPP_URL = [
  UTM_SOURCE,
  UTM_MEDIUM,
  UTM_CAMPAIGN,
  LANDING_PAGE
];

export const WA_FLOAT_ICON = "Floating Icon";
export const WA_VENUE_TILE = "Venue Tile";
export const WA_VENUE_PRICING = "Venue Pricing";
export const WA_VENUE_BOTTOM_SEGMENT = "Venue Bottom Segment";
export const WA_SEARCH_PAGE_BOTTOM_SEGMENT = "Search Page Bottom Segment";
export const WA_REVIEW_CONNECT_TO_EXPERT = "Review Connect To Expert";

export const HOME_PAGE_ENUM = "Home Page"; // OK
export const SEARCH_PAGE_ENUM = "Search Page"; // OK
export const VENUE_PAGE_ENUM = "Venue Page"; // OK
export const QUOTES_PAGE_ENUM = "Quotes Page";
export const VENDOR_PAGE_ENUM = "Vendor Page";
export const QNA_PAGE_ENUM = "Qna Page"; 
export const BLOG_PAGE_ENUM = "Blog Page"; // OK
export const COLLECTION_PAGE_ENUM = "Collection Page"; // OK
export const COLLECTION_DETAILS_ENUM = "Collection Details"; // OK
export const REAL_EVENTS_ENUM = "Real Events"; //OK
export const REAL_EVENT_DETAIL_ENUM = "Real Event Detail"; //OK
export const BLOG_DETAIL_PAGE = "Blog Detail Page"; // OK
export const BLOG_AUTHOR_PAGE = 'Blog Author Page' // OK
export const BLOG_CATAGORY_PAGE ='Blog Catagory Page' //OK

export const UTM_SOURCE_VALUE = { google: "01", instagram: "02", facebook: "03" }

export const APP_SOURCE_VALUE = { customer_mobile: "01", customer_desktop: "02" }

export const keyEncoder = {
    [UTM_SOURCE]: "us",
    [UTM_MEDIUM]: "um",
    [UTM_CAMPAIGN]: "uc",
    [BTN_SOURCE]: "b",
    [APP_SOURCE]: "a",
    [LANDING_PAGE]: "lp"
  };

  export const PagesEncodeEnum = {
    [HOME_PAGE_ENUM]: "01",
    [SEARCH_PAGE_ENUM]: "02",
    [VENUE_PAGE_ENUM]: "03",
    [QUOTES_PAGE_ENUM]: "04",
    [VENDOR_PAGE_ENUM]: "05",
    [QNA_PAGE_ENUM]: "06",
    [BLOG_PAGE_ENUM]: "07",
    [COLLECTION_PAGE_ENUM]: "08",
    [COLLECTION_DETAILS_ENUM]: "09",
    [REAL_EVENTS_ENUM]: "10",
    [REAL_EVENT_DETAIL_ENUM]: "11",
    [BLOG_DETAIL_PAGE]:"12",
    [BLOG_AUTHOR_PAGE]:"13",
    [BLOG_CATAGORY_PAGE]:"14"
  };

  export const WHATS_APP_PLACEMENTS_ENC = {
    [WA_FLOAT_ICON]: 'fi',
    [WA_VENUE_TILE]: 'vt',
    [WA_VENUE_PRICING]: 'vp',
    [WA_VENUE_BOTTOM_SEGMENT]: 'bs',
    [WA_REVIEW_CONNECT_TO_EXPERT]: 'rcte',
    [WA_SEARCH_PAGE_BOTTOM_SEGMENT]:'sbs'
  };  
    
  
export const value_mapper = {
    [UTM_SOURCE]: UTM_SOURCE_VALUE,
    [APP_SOURCE]: APP_SOURCE_VALUE,
    Pages: PagesEncodeEnum,
    btn_Placements: WHATS_APP_PLACEMENTS_ENC
  };



 
  